import { CURRENCY_SYMBOL } from '../constants';
import { JALUZI_SISTEM_TIPLERI } from '../constants';
import { getUsdToKztRate } from './exchangeRates';

export const PRODUCT_PRICE_CURRENCY_USD = 'USD';

const JALUZI_PRICE_FIELDS = [
  'merdivenIpliFiyat', 'merdivenIpliMaliyet', 'merdivenIpliToptan',
  'kurdeleliFiyat', 'kurdeleliMaliyet', 'kurdeleliToptan',
  'merdivenIpliReduktorluFiyat', 'merdivenIpliReduktorluMaliyet', 'merdivenIpliReduktorluToptan',
  'kurdelaliReduktorluFiyat', 'kurdelaliReduktorluMaliyet', 'kurdelaliReduktorluToptan'
];

const STANDARD_PRICE_FIELDS = ['unitPrice', 'wholesalePrice', 'cost'];

export const isProductPriceInUsd = (product) => {
  if (!product) return false;
  if (product.priceCurrency === PRODUCT_PRICE_CURRENCY_USD) return true;
  if (product.priceCurrency === 'KZT') return false;
  if (product.productType === 'rustik') return false;
  // Eski kayıtlar: rustik dışındaki katalog fiyatları USD olarak saklanır
  return product.priceCurrency == null;
};

export const convertUsdAmountToKzt = (usdAmount, exchangeRates) => {
  const usd = parseFloat(usdAmount) || 0;
  if (!usd) return 0;
  return usd * getUsdToKztRate(exchangeRates);
};

export const toKztPrice = (amount, product, exchangeRates) => {
  const value = parseFloat(amount) || 0;
  if (!value) return 0;
  if (isProductPriceInUsd(product)) {
    return convertUsdAmountToKzt(value, exchangeRates);
  }
  return value;
};

export const convertProductToKztForOrder = (product, exchangeRates) => {
  if (!product || !isProductPriceInUsd(product)) return product;

  const rate = getUsdToKztRate(exchangeRates);
  const convert = (v) => {
    const n = parseFloat(v) || 0;
    return n ? Number((n * rate).toFixed(2)) : 0;
  };

  const converted = { ...product };
  [...STANDARD_PRICE_FIELDS, ...JALUZI_PRICE_FIELDS].forEach((field) => {
    if (converted[field] !== undefined && converted[field] !== null && converted[field] !== '') {
      converted[field] = convert(converted[field]);
    }
  });
  return converted;
};

export const resolveJaluziOrderPricing = (product, sistemTipi, isWholesale = false) => {
  if (!product) return { price: '', cost: 0 };

  const retailWholesaleCost = (retail, wholesale, cost) => ({
    price: isWholesale ? (wholesale || retail || '') : (retail || ''),
    cost: cost || 0
  });

  if (sistemTipi === JALUZI_SISTEM_TIPLERI.merdivenIpli) {
    return retailWholesaleCost(product.merdivenIpliFiyat, product.merdivenIpliToptan, product.merdivenIpliMaliyet);
  }
  if (sistemTipi === JALUZI_SISTEM_TIPLERI.kurdeleli) {
    return retailWholesaleCost(product.kurdeleliFiyat, product.kurdeleliToptan, product.kurdeleliMaliyet);
  }
  if (sistemTipi === JALUZI_SISTEM_TIPLERI.merdivenIpliReduktorlu) {
    return retailWholesaleCost(
      product.merdivenIpliReduktorluFiyat,
      product.merdivenIpliReduktorluToptan,
      product.merdivenIpliReduktorluMaliyet
    );
  }
  if (sistemTipi === JALUZI_SISTEM_TIPLERI.kurdelaliReduktorlu) {
    return retailWholesaleCost(
      product.kurdelaliReduktorluFiyat,
      product.kurdelaliReduktorluToptan,
      product.kurdelaliReduktorluMaliyet
    );
  }

  return {
    price: isWholesale
      ? (
        product.merdivenIpliToptan || product.kurdeleliToptan ||
        product.merdivenIpliReduktorluToptan || product.kurdelaliReduktorluToptan ||
        product.merdivenIpliFiyat || product.kurdeleliFiyat || ''
      )
      : (
        product.merdivenIpliFiyat || product.kurdeleliFiyat ||
        product.merdivenIpliReduktorluFiyat || product.kurdelaliReduktorluFiyat || ''
      ),
    cost: product.merdivenIpliMaliyet || product.kurdeleliMaliyet ||
      product.merdivenIpliReduktorluMaliyet || product.kurdelaliReduktorluMaliyet || 0
  };
};

export const formatStoredPriceAsKzt = (amount, product, exchangeRates, formatPrice) => {
  const kzt = toKztPrice(amount, product, exchangeRates);
  if (!kzt) return '—';
  return `${formatPrice(kzt)} ${CURRENCY_SYMBOL}`;
};

export const formatUsdKztHint = (usdAmount, exchangeRates, formatPrice) => {
  const hint = convertUsdAmountToKzt(usdAmount, exchangeRates);
  if (!hint) return null;
  return `≈ ${formatPrice(hint)} ${CURRENCY_SYMBOL}`;
};

const MECHANISM_PRICE_FIELDS = ['cost', 'price', 'wholesale'];

export const isMechanismPriceInUsd = (mechanism) => mechanism?.priceCurrency === PRODUCT_PRICE_CURRENCY_USD;

export const convertMechanismToKztForOrder = (mechanism, exchangeRates) => {
  if (!mechanism || !isMechanismPriceInUsd(mechanism)) return mechanism;

  const rate = getUsdToKztRate(exchangeRates);
  const convert = (v) => {
    const n = parseFloat(v) || 0;
    return n ? Number((n * rate).toFixed(2)) : 0;
  };

  const converted = { ...mechanism };
  MECHANISM_PRICE_FIELDS.forEach((field) => {
    if (converted[field] !== undefined && converted[field] !== null && converted[field] !== '') {
      converted[field] = convert(converted[field]);
    }
  });
  return converted;
};

export const formatProductListPrice = (amount, product, exchangeRates, formatPrice) => {
  const value = parseFloat(amount) || 0;
  if (!value) {
    return { primary: '—', hint: null };
  }

  if (isProductPriceInUsd(product)) {
    return {
      primary: `$${formatPrice(value)}`,
      hint: formatUsdKztHint(value, exchangeRates, formatPrice)
    };
  }

  return {
    primary: `${formatPrice(value)} ${CURRENCY_SYMBOL}`,
    hint: null
  };
};
